import {Component, Input} from '@angular/core';

import {Market} from '../../../model';

@Component({
  selector: 'timecard-details-table-daily-rate',
  templateUrl: './timecard-details-table-daily-rate.component.html',
  styleUrls: ['./timecard-details-table-daily-rate.component.scss']
})
export class TimecardDetailsTableDailyRateComponent {

  @Input() timecardDays: TimecardDay[] = [];
  parisMarket: Market = Market.Paris;

}
